/*
 * @description:
 * @author: wolfgun
 * @Date: 2020-10-16 16:13:22
 */

export const STATUS = [
  { showName: '成功', dictionaryId: 0 },
  { showName: '爽约', dictionaryId: 1 }
]
